// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCrownOutlinedSvg from "@fishx/icons-svg/es/asn/PCrownOutlined";
import FishxIcon from '../components/FishxIcon';

var PCrownOutlined = function PCrownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCrownOutlinedSvg
  }));
};

PCrownOutlined.displayName = 'PCrownOutlined';
export default React.forwardRef(PCrownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCrownOutlined.js
// module id = 3318
// module chunks = 0